export const assessmentTemplate = [
  {
    _id: "botpressCUAccounts",
    omniAudit: {
      auditVersion: "1",
      omniRevision: "1",
      omniSchema: "assessmentTemplate",
      omniSchemaVersion: "1",
      writtenBy: null,
      createdBy: "rlund3",
      createdDate: "2025-12-10T00:00:00Z",
      modifiedBy: null,
      modifiedDate: null,
      isActive: true,
    },
    omniData: {
      omniType: "botpressCUAccounts",
      omniTypeVersion: 1,
      title: "Customer Questions about Accounts",
      description: "This is a collection of account-related queries.",
      duration: "A little less than a bit",
      directions: "Do not close your browser window until the assessment is complete.",
      attribution: "Omniscia AI Team. All Rights Reserved.",
      validated: true,
      selfAssessment: true,
      startDate: null,
      completeDate: null,
      questions: [
        {
          omniID: "BOT001",
          numberText: "1",
          text: "What is my account balance?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT002",
          numberText: "2",
          text: "How do I view my transactions?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT003",
          numberText: "3",
          text: "How do I find my account number?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT004",
          numberText: "4",
          text: "How do I open a new account?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT005",
          numberText: "5",
          text: "How do I close my account?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT006",
          numberText: "6",
          text: "How do I transfer money between accounts?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT007",
          numberText: "7",
          text: "How do I add an external account?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT008",
          numberText: "8",
          text: "How do I set up direct deposit?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT009",
          numberText: "9",
          text: "How do I change my account nickname?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT010",
          numberText: "10",
          text: "How do I download my statements?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT011",
          numberText: "11",
          text: "How do I get a voided check?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT012",
          numberText: "12",
          text: "How do I reorder checks?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT013",
          numberText: "13",
          text: "How do I update my personal information?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT014",
          numberText: "14",
          text: "How do I reset my password?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT015",
          numberText: "15",
          text: "How do I freeze my account?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT016",
          numberText: "16",
          text: "How do I report an unauthorized transaction?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT017",
          numberText: "17",
          text: "Why is my balance different from available balance?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT018",
          numberText: "18",
          text: "How do I set up account alerts?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT019",
          numberText: "19",
          text: "How do I link another person to my account?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT020",
          numberText: "20",
          text: "How do I find my routing number?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT021",
          numberText: "21",
          text: "How do I see pending transactions?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT022",
          numberText: "22",
          text: "How do I export transactions to Excel?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT023",
          numberText: "23",
          text: "How do I hide or remove an account?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT024",
          numberText: "24",
          text: "How do I dispute a transaction?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT025",
          numberText: "25",
          text: "How do I get tax forms for my account?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
      ],
      assessmentResults: {
        finalResult: null,
      },
    },
  },
];

export const assessmentScoring = [
  {
    typeID: "botpressCUAccounts",
    algorithms: [
      {
        name: "sum",
        minScore: 0,
        maxScore: 20,
        formula: null,
        questions: [],
      },
    ],
  },
];
